<template>
	<div class="osBody" style="overflow: auto;height: 100%;">
            <el-input size="small" placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
            <el-tree
                :data="treeData"
                :props="defaultProps"
                :default-expanded-keys="defaultExpandedKeys"
                :filter-node-method="filterNode"
                :expand-on-click-node="false"
                accordion
                node-key="id"
                v-loading="treeDataLoading"
                highlight-current
                ref="tree"
                @node-click="chooseNode"
            >
            </el-tree>
        <!-- </transition> -->
        <!-- <div class="TreeDivOne" @click="collapse">
            <i class="el-icon-d-arrow-left"></i>
            </div>
        </div> -->
	</div>
</template>

<script>
import { get } from "@/assets/common/request";
export default {
	name: "LeftFloorTree",
	data() {
		return {
            treeDataLoading: false,
            show: true,
            iconSrc: '',
			treeData: [],
			filterText: "",
			defaultExpandedKeys: [],
			defaultProps: {
				value: "id", // 唯一标识
				label: "label", // 标签显示
				children: "children", // 子级
			},
		};
	},
	methods: {
		chooseNode(nodeData, node, treeComponent) {
			let officeId = "";
			let projectId = "";
			let floorId = "";
			if (node.level == 1) {
				officeId = node.data.id;
			}
			if (node.level == 2) {
				projectId = node.data.id;
				officeId = node.parent.data.id;
			}
			if (node.level == 3) {
				floorId = node.data.id;
				projectId = node.parent.data.id;
				officeId = node.parent.parent.data.id;
			}
			let data = {
				officeId,
				projectId,
				floorId,
			};
			this.$emit("chooseNode", data);
		},
		loadTreeData() {
            this.treeDataLoading = true;
			const floorTreeurl = this.$requestUrl.GET_FLOOR_TREE;
			const url = floorTreeurl;
			get(url)
            .then((data) => {
				this.treeData = data.data;
			})
            .finally(() => {
                this.treeDataLoading = false;
            });
		},
		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},
        collapse() {
            this.show = !this.show;
        }
	},
	watch: {
        show(val) {
            if(val) {
                this.iconSrc = require('../assets/images/zuo@3x.png');
            }else {
                this.iconSrc = require('../assets/images/you@3x.png');
            }
        },
		treeData: {
			handler() {
				this.treeData.forEach((item) => {
					this.defaultExpandedKeys.push(item.id);
				});
			}
		},
        filterText(val) {
            setTimeout(() => {
                this.$refs.tree.filter(val);
            }, 500); 
        },
	},
	mounted() {
		this.loadTreeData();
	},
};
</script>

<style scoped lang="scss">
.osBody {
	width: 220px;
	height: 500px;
	float: left;
	margin-right: 1%;
	overflow-y: scroll;
}
.TreeDivOne{
    width: 25px;
  height: 70px;
  border-radius: 10px;
  z-index: 500;
  position: relative;
  top: 45%;
  left: 220px;
}
</style>
